module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("My Life had stood - a Loaded Gun -")])]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("In Corners - till a Day")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("The Owner passed - identified -")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("And carried Me away -")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—EMILY DICKINSON")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0